/* eslint-disable import/no-named-as-default */
/* eslint-disable import/no-named-as-default-member */
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import useCart from '../../data/cart/use';
import api, { isAuthenticated } from '../../data/store/api';

import NumberInput from '../NumberInput';
import VariationSelector from './VariationSelector';
import Summary from './Summary';
import { Loader } from '../Loader';
import {
  ModalContainer as Container,
  Box,
  Details,
  Row,
  Col,
  Button,
  HidePrice,
} from './styles';

import Select from '../Select';
import { Product } from '../../entities';
import { numberFormat } from '../../helpers';
import Alert from '../Alert';

const View = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();

  const sku = searchParams.get('sku');
  const { cart, dispatch } = useCart();
  const [qtty, setQtty] = useState(1);
  const [notes, setNotes] = useState(null);
  const [gemId, setGemId] = useState(0);
  const [metalId, setMetalId] = useState(0);
  const [product, setProduct] = useState(null);
  const [variation, setVariation] = useState(null);
  const [isRing, setIsRing] = useState(false);

  const setSelectedVariation = (productVariation) => {
    setVariation(productVariation);
    setSearchParams({ sku: productVariation.sku });
    setMetalId(productVariation?.metal?.id);
    setGemId(productVariation?.gem?.id);
  };

  const handleClose = () => {
    const lastUrl = localStorage.getItem('last');
    if (lastUrl) {
      navigate(lastUrl);
    } else {
      navigate('/');
    }
  };

  useEffect(() => {
    if (variation) {
      const result = cart?.items.filter(
        (item) => item.variation.id === variation.id,
      );
      if (result[0]) {
        const prodNotes = result[0].notes;
        const prodQtty = result[0].qtty > 0 ? result[0].qtty : 1;
        setNotes(prodNotes);
        setQtty(prodQtty);
      }
    }
  }, [variation]);

  useEffect(() => {
    if (qtty === 0) {
      dispatch({ type: 'REMOVE_ITEM', payload: { qtty, variation } });
    }
  }, [qtty]);

  useEffect(() => {
    async function fetchProductById() {
      api.getProductById(id).then((resp) => {
        if (resp instanceof Product) {
          setProduct(resp);
        }
      });
    }
    fetchProductById();
  }, [id]);

  useEffect(() => {
    if (product) {
      if (!sku) {
        if (product?.variations) {
          setSelectedVariation(product?.variations[0]);
        }
      } else {
        const selectedVariation = product?.variations.find(
          (vari) => vari.sku === sku,
        );
        setSelectedVariation(selectedVariation);
      }
      if (product?.jewelryType?.title) {
        setIsRing(/(?:^|\W)ring(?:$|\W)/gim.test(product.jewelryType.title));
      }
    }
  }, [product, sku]);

  useEffect(() => {
    const newVariation = product?.variations.find(
      (vari) =>
        metalId &&
        vari.metal.id === Number(metalId) &&
        gemId &&
        vari.gem.id === Number(gemId),
    );
    if (newVariation && newVariation.sku !== sku) {
      setSearchParams({ sku: newVariation.sku });
    }
  }, [metalId, gemId]);

  return (
    <>
      {product && variation ? (
        <Container className="modal">
          <Summary
            className="summary"
            variation={variation}
            product={product}
            isModal
          />

          <Details className="details">
            <Row>
              <VariationSelector product={product} />
            </Row>
            <Row>
              <Col style={{ marginRight: '8px' }}>
                {product?.collection?.title && (
                  <Row>
                    <Box>
                      <small>Collection:</small>
                      <h4>{product.collection.title}</h4>
                    </Box>
                  </Row>
                )}

                <Row>
                  <Box>
                    <small>SKU:</small>
                    <h4>{variation?.sku}</h4>
                  </Box>
                </Row>

                {product?.jewelryType?.title && (
                  <Row>
                    <Box>
                      <small>Type:</small>
                      <h4>{product?.jewelryType?.title}</h4>
                    </Box>
                  </Row>
                )}

                {product?.description && (
                  <Row>
                    <Box>
                      <small>Description:</small>
                      <h4 className="description">{product?.description}</h4>
                    </Box>
                  </Row>
                )}

                <Row>
                  <Box>
                    <small>Retail price:</small>
                    <h4>{numberFormat(variation?.retailPrice)}</h4>
                  </Box>
                </Row>
              </Col>

              <Col>
                {product?.metals && (
                  <Row>
                    <Box>
                      <>
                        <small>Metal:</small>
                        <Select
                          onChange={(e) => {
                            setMetalId(e.target.value);
                          }}
                          name="metals"
                          items={product?.metals}
                          value={metalId || ''}
                        />
                      </>
                    </Box>
                  </Row>
                )}

                {product?.gems && (
                  <Row>
                    <Box>
                      <>
                        <small>Gem:</small>
                        <Select
                          onChange={(e) => {
                            setGemId(e.target.value);
                          }}
                          name="gems"
                          items={product?.gems}
                          value={gemId || ''}
                        />
                      </>
                    </Box>
                  </Row>
                )}

                {false && (
                  <Row>
                    <Box>
                      {isRing && (
                        <>
                          <small>Notes:</small>
                          <textarea
                            placeholder="Standard size"
                            name="ringSize"
                            defaultValue={notes || ''}
                            onFocus={(e) => {
                              const val = e.target.value;
                              if (val === '') {
                                setNotes('ring sizes: ');
                              }
                            }}
                            onBlur={(e) => {
                              const val = e.target.value;
                              if (val === 'ring sizes: ') {
                                setNotes('');
                              }
                            }}
                            onKeyUp={(e) => {
                              setNotes(e.target.value);
                            }}
                          />
                        </>
                      )}
                    </Box>
                  </Row>
                )}

                {product?.chainTypes && (
                  <Row>
                    <Box>
                      <>
                        <small>Chain Type:</small>
                        <Select
                          onChange={() => {}}
                          name="chainType"
                          items={product?.chainTypes}
                        />
                      </>
                    </Box>
                  </Row>
                )}

                {product?.chainLengths && (
                  <Row>
                    <Box>
                      <>
                        <small>Chain Lenght:</small>
                        <Select
                          onChange={() => {}}
                          name="chainLength"
                          items={product?.chainLengths}
                          value=""
                        />
                      </>
                    </Box>
                  </Row>
                )}

                {isAuthenticated() && (
                  <Row>
                    <Box>
                      <>
                        <small>Note:</small>
                        <textarea
                          name="notes"
                          defaultValue={notes || ''}
                          onKeyUp={(e) => {
                            setNotes(e.target.value);
                          }}
                        />
                      </>
                    </Box>
                  </Row>
                )}
              </Col>
            </Row>

            <>
              <Row>
                <Col>
                  <Box className="price-box">
                    <small>Wholesale price:</small>
                    {isAuthenticated() ? (
                      <h3>{numberFormat(variation?.wholesalePrice)}</h3>
                    ) : (
                      <HidePrice>$00.00</HidePrice>
                    )}
                  </Box>
                </Col>
                <Col>
                  <Box className="price-box total">
                    <small>Total amount:</small>
                    {isAuthenticated() ? (
                      <h3>{numberFormat(variation?.wholesalePrice * qtty)}</h3>
                    ) : (
                      <HidePrice>$00.00</HidePrice>
                    )}
                  </Box>
                </Col>
              </Row>

              {!isAuthenticated() && (
                <Row>
                  <Alert>Please sign to view price and to place orders</Alert>
                </Row>
              )}
              {isAuthenticated() && (
                <Row>
                  <Alert info>Delivery within 6-8 weeks</Alert>
                </Row>
              )}
              <Row className="number-input-container">
                <NumberInput
                  defaultValue={qtty}
                  min={1}
                  onChange={setQtty}
                  style={{ marginRight: '0.5rem' }}
                />

                <Button
                  onClick={(e) => {
                    e.preventDefault();

                    dispatch({
                      type: 'ADD_ITEM',
                      payload: {
                        qtty,
                        variation,
                        product,
                        notes: notes === '' ? 'Standard size' : notes,
                      },
                    });
                    if (product?.variations.length === 1) {
                      handleClose();
                    }
                  }}
                >
                  ADD TO BAG
                </Button>
              </Row>
            </>
          </Details>
        </Container>
      ) : (
        <Loader />
      )}
    </>
  );
};

export default View;
